export default __webpack_public_path__ + "images/b9528817ac68601855eb3193e4bd876f.svg";